const COUNTRY_CODES = {
  EUR: "eu",
  USD: "us",
  GBP: "gb",
  CHF: "ch",
  AUD: "au",
  CAD: "ca",
  DKK: "dk",
  HUF: "hu",
  JPY: "jp",
  NOK: "no",
  SEK: "se",
  TRL: "tr",
  PLN: "pl",
  CZK: "cz",
  RON: "ro",
};

export const getFlag = (code) => {
  const country = COUNTRY_CODES[code];
  if (!country) return null;
  return `https://flagcdn.com/w40/${country}.png`;
};
